/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const ProductUploadHistoryItemDTOUpdateTypeEnum = {
    Add: 'ADD',
    Patch: 'PATCH',
    Delete: 'DELETE'
};
/**
 * @export
 */
export const ProductUploadHistoryItemDTOJobStatusEnum = {
    Ready: 'READY',
    Pending: 'PENDING',
    Submitted: 'SUBMITTED',
    Processing: 'PROCESSING',
    Completed: 'COMPLETED',
    Succeeded: 'SUCCEEDED',
    Failed: 'FAILED',
    Cancelled: 'CANCELLED'
};
/**
 * Check if a given object implements the ProductUploadHistoryItemDTO interface.
 */
export function instanceOfProductUploadHistoryItemDTO(value) {
    return true;
}
export function ProductUploadHistoryItemDTOFromJSON(json) {
    return ProductUploadHistoryItemDTOFromJSONTyped(json, false);
}
export function ProductUploadHistoryItemDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'asin': json['asin'] == null ? undefined : json['asin'],
        'sku': json['sku'] == null ? undefined : json['sku'],
        'targetMarket': json['targetMarket'] == null ? undefined : json['targetMarket'],
        'minPrice': json['minPrice'] == null ? undefined : json['minPrice'],
        'maxPrice': json['maxPrice'] == null ? undefined : json['maxPrice'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'updateType': json['updateType'] == null ? undefined : json['updateType'],
        'jobStatus': json['jobStatus'] == null ? undefined : json['jobStatus'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
        'submittedAt': json['submittedAt'] == null ? undefined : (new Date(json['submittedAt'])),
        'completedAt': json['completedAt'] == null ? undefined : (new Date(json['completedAt'])),
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
    };
}
export function ProductUploadHistoryItemDTOToJSON(json) {
    return ProductUploadHistoryItemDTOToJSONTyped(json, false);
}
export function ProductUploadHistoryItemDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'asin': value['asin'],
        'sku': value['sku'],
        'targetMarket': value['targetMarket'],
        'minPrice': value['minPrice'],
        'maxPrice': value['maxPrice'],
        'quantity': value['quantity'],
        'updateType': value['updateType'],
        'jobStatus': value['jobStatus'],
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
        'submittedAt': value['submittedAt'] == null ? undefined : ((value['submittedAt']).toISOString()),
        'completedAt': value['completedAt'] == null ? undefined : ((value['completedAt']).toISOString()),
        'errorMessage': value['errorMessage'],
    };
}
